import { ADD_COUNTER, SUB_COUNTER } from "./actionsTypes";
const addValue = (value) => ({ type: ADD_COUNTER, value });
const subValue = (value) => ({ type: SUB_COUNTER, value });

export { addValue, subValue };
